module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-10-68f500bf32a5d252b9a6c12977d8e1b9.jpg";